import Layout from 'antd/es/layout';

export default Layout;
